// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"7551fabb","786":"39bd774d","981":"d3e2a5c0"}[chunkId] + ".chunk.js";
};